var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://cdn.mekoom.com/assets-v3/certificate/增值电信业务经营许可.jpg","alt":""}})])
}]

export { render, staticRenderFns }